import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar.component';
import { RouterModule } from '@angular/router';
import { TreeModule } from 'src/app/core/tree/tree.module';
import {MatMenuModule} from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    SidebarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TreeModule,
    MatMenuModule,
    MatTooltipModule
  ],
  exports: [
    SidebarComponent
  ]
})
export class SidebarModule{ }
